import axios from 'axios';
import {
    notification
} from 'antd';
import {
    getAccessToken
} from './auth';
import {
    API_PATH
} from '../appConstants';

const codeMessage = {};

const client = axios.create({
    baseURL: API_PATH,
});

function checkStatus(error) {
    const response = error.response;
    if (response) {
        const errorText = codeMessage[response.status] || response.statusText;
        notification.error(
            {
                message: `Request failed ${response.status}: ${response.request.responseURL}`,
                description: errorText,
            }
        );

        const error = new Error(errorText);
        error.name = response.status;
        error.response = response;
        throw error;
    } else {
        throw new Error(error.message);
    }
}

/**
 * Requests a url, returning a promise.
 * 
 * @param       {string} url            The url we want to request
 * @param       {object} [options]      The options we want to pass to axios
 * @return      {object}                An object containing either "data" or "err"
 */
export default function request(url, options) {
    const defaultOptions = {
        headers: {
            Authorization: getAccessToken(),
        }
    };

    const newOptions = {
        url,
        ...defaultOptions,
        ...options
    };

    if (newOptions.method === 'POST' || newOptions.method === 'PUT' || newOptions.method === 'DELETE') {
        if (!(newOptions.body instanceof FormData)) {
            newOptions.headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                ...newOptions.headers,
            };
        } else {
            // body is FormData
            newOptions.headers = {
                Accept: 'application/json',
                ...newOptions.headers,
            };
        }
    }

    return client(newOptions)
        // .then(checkStatus)
        .then(response => {
            return response.data;
        })
        .catch(checkStatus)
        .catch(err => {
            // handle errors. eg. redirect to error page
            console.log(err);
        });
}


// WEBPACK FOOTER //
// ./src/utils/request.js